import React, { Component } from 'react';
import { Col,  Row } from 'react-bootstrap';
import AdminLayout from './AdminLayout';
import AdminPublicEventList from '../components/admin/AdminPublicEventList';
import '../css/style.css';
import '../components/Home.css';

class AdminPublicEventLayout extends Component {

    render(){
        return (
            <AdminLayout eventKey="2">
                <Row>
                    <Col >
                    <AdminPublicEventList />
                    </Col>
                </Row>
            </AdminLayout>              
        );
    }

}

export default AdminPublicEventLayout;